import { createAction } from '@reduxjs/toolkit';

import { PServiceFilterItem } from '@/types/filters';
import { WithCities } from '@/types/platform-data';

import { Filters } from './polako-service-filters.types';

export const pServiceFiltersKey = 'pServiceFiltersKey';

export interface PServiceFiltersState {
    readonly filtersAvailable: Filters;
    readonly filtersSelected: Filters;
}

export enum pServiceFiltersActionTypes {
    filtersLoad = 'pServiceFilters/filtersLoad',
    filtersLoadSuccess = 'pServiceFilters/filtersLoadSuccess',

    filterSelect = 'pServiceFilters/filterSelect',
    filterDeselect = 'pServiceFilters/filterDeselect',
    filtersReset = 'pServiceFilters/filtersReset',
}

export const filtersLoad = createAction<WithCities>(pServiceFiltersActionTypes.filtersLoad);
export const filtersLoadSuccess = createAction<{ filters: Filters }>(pServiceFiltersActionTypes.filtersLoadSuccess);

export const filterSelect = createAction<PServiceFilterItem>(pServiceFiltersActionTypes.filterSelect);
export const filterDeselect = createAction<PServiceFilterItem>(pServiceFiltersActionTypes.filterDeselect);
export const filtersReset = createAction(pServiceFiltersActionTypes.filtersReset);

export type PServiceFiltersActions =
    | ReturnType<typeof filtersLoad>
    | ReturnType<typeof filtersLoadSuccess>
    | ReturnType<typeof filterSelect>
    | ReturnType<typeof filterDeselect>
    | ReturnType<typeof filtersReset>;
